export default __webpack_public_path__ + "static/media/skyvid.c4694c18.mp4";